import styled from "styled-components";
import { LoadingIcon } from "./icons/LoadingIcon";

type Props = {
  isShown?: boolean;
};

export const LoadingIndicator: React.FC<Props> = ({ isShown }) => {
  if (!isShown) return null;

  return <StyledLoadingBackground />;
};

const StyledLoadingBackground = styled.div`
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: wait;
`;
